import { createTheme } from '@mui/material/styles';
import { GFBrand } from '../models/GFBrand';

export const muiTheme = createTheme({
    palette: GFBrand.THEME.palette,
});
